/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button } from "shared/Components/button";
import moment from "moment";
import { DEFAULT_DATE_FORMAT } from "helper/utility";

export const ResultCard = ({
  trial,
  search,
  host,
  breed,
  onViewResult,
  date,
  qNq,
  dog,
}) => {
  // Remove duplicate levels from the search array
  const getUniqueLevels = () => {
    if (dog) return dog;
    if (!search) return "";

    const levels = search.map((sc) => sc?.level);
    const uniqueLevels = [...new Set(levels)];
    return uniqueLevels.join(", ");
  };

  // Fix status text: "Close" -> "Closed"
  const getStatus = () => {
    const status = qNq || trial?.status;
    return status === "Close" ? "Closed" : status;
  };

  return (
    <div class="bg-white p-4">
      <div class="flex justify-between items-center">
        <h2 class="text-lg font-semibold text-gray-900 w-7/12">
          {moment(trial?.trialDate || date).format(DEFAULT_DATE_FORMAT)}
        </h2>
        <a
          href="#"
          class="text-sm ml-4 px-2.5 py-0.5 rounded-[16px] border-[1px] border-solid border-black bg-[#F9FAFB]"
        >
          {getUniqueLevels()}
        </a>
      </div>
      <p class="text-gray-600 text-sm mb-4">{breed || host?.hostName}</p>
      <div class="flex justify-between items-center">
        <div>
          <p class="text-gray-800 text-sm font-semibold">Status</p>
          <p class="text-gray-900 text-sm">{getStatus()}</p>
        </div>
        <Button label="View More" width="w-32" onClick={onViewResult} />
      </div>
    </div>
  );
};
